import {jwtDecode} from 'jwt-decode'
import axios from "axios"
import { URL, OAUTH, JWT_NAME } from "app/config/api-config"
import { LocaleType } from 'trans'

axios.defaults.baseURL = URL.rootUrl

const TOKEN_TTL = 60

const FALLBACK_LOCALE = "cs_CZ"

export const REDIRECT_BACK = "fie_redirect_back"


export function makeAuth(projectId, pathname) {
    sessionStorage.setItem(REDIRECT_BACK, pathname)
    window.location.href = getOAuthUrl(projectId)
}

export function getOAuthUrl(entityId) {
    return `${OAUTH.baseUrl}?${OAUTH.client_id}&${OAUTH.response_type}&${OAUTH.redirect_uri}&${OAUTH.approval_prompt}&entity_id=${entityId}`
}

export function checkToken(entityId): boolean {
    const token = sessionStorage.getItem(JWT_NAME)
    if (!token) {
        return false
    }

    const decodedToken : any = jwtDecode(token)

    //check expire timestamp against current
    if (decodedToken.exp < Math.floor(Date.now() / 1000)) {
        sessionStorage.removeItem(JWT_NAME)
        return false
    }

    if (decodedToken.entity_id != entityId) {
        sessionStorage.removeItem(JWT_NAME)
        return false
    }

    return true
}

export function deleteToken(): boolean {
    const token = sessionStorage.getItem(JWT_NAME)
    if (!token) {
        return true
    }

    sessionStorage.removeItem(JWT_NAME)

    return true
}

export function setToken(token: string): void {
    sessionStorage.setItem(JWT_NAME, token)
}

export function getRawToken() {
    const token = sessionStorage.getItem(JWT_NAME)
    if (!token) {
        return false
    }

    const decodedToken : any = jwtDecode(token)
    if (decodedToken.exp < Math.floor(Date.now() / 1000)) {
        sessionStorage.removeItem(JWT_NAME)
        return false
    }

    return token
}

export function getToken() {
    const token = sessionStorage.getItem(JWT_NAME)
    if (!token) {
        return false
    }

    const decodedToken : any = jwtDecode(token)
    if (decodedToken.exp < Math.floor(Date.now() / 1000)) {
        sessionStorage.removeItem(JWT_NAME)
        return false
    }

    return decodedToken
}

export function createToken(code): Promise<any> {
    return new Promise((resolve, reject) => {
        let request = axios.post("/auth", {
            code: code
        })
            .then((response: any) => {
                setToken(response.data.token)

                resolve(response.data.token)
            }).catch(error => {
                reject(error)
            })
    })
}

export function getLocale() : LocaleType {
    const token = getToken()
    return token.locale ? token.locale : FALLBACK_LOCALE
}


export function checkTokenExpire(redirect) {
    const exp: number = getTokenExpiration()
    const timeout = (exp - new Date().getTime()) / 1000
    if (timeout < 10 * 60) {
        deleteToken()
        location.reload()
        console.debug('Token will expire, reloading window')
    }
}

export function getTokenExpiration() {
    const token = sessionStorage.getItem(JWT_NAME)
    if (!token) {
        return 0
    }

    const decodedToken : any = jwtDecode(token)
    const exp : number = decodedToken.exp * 1000
    console.debug("Token will expire: " + new Date(exp).toString())
    return exp
}

